@if (segment$ | async; as segment) {
  <elder-pane padding="0" flat class="outlined full">
    <elder-pane-header>
      <elder-pane-title class="text-title-medium">
        Segment {{ segment.capability }}
      </elder-pane-title>
    </elder-pane-header>
    <elder-pane-content>
      <mat-tab-group class="flex">
        <mat-tab label="Detail">
          <div class="layout-col full p-md">
            <div class="layout-row place-start-center gap-sm p-sm">
              <mat-form-field elderFormFieldLabel>
                <mat-label>{{ 'capabilities.capability' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="capability"
                  [ngModel]="segment.capability"
                  readonly
                  placeholder="{{ 'capabilities.capability' | translate }}"
                />
              </mat-form-field>
              <mat-form-field elderFormFieldLabel>
                <mat-label>{{ 'context.status' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="state"
                  [ngModel]="'WorkItemState.' + segment.state | translate"
                  readonly
                  placeholder="{{ 'context.status' | translate }}"
                />
              </mat-form-field>
              <mat-form-field elderFormFieldLabel>
                <mat-label>{{ 'validation.title' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="validationState"
                  [ngModel]="'validation.states.' + segment.validationState | translate"
                  readonly
                  placeholder="{{ 'validation.title' | translate }}"
                />
              </mat-form-field>
            </div>
            <elder-label-input
              readonly
              class="p-sm"
              [value]="segment.actions"
              [placeholder]="'operations.title' | translate"
            >
            </elder-label-input>
            <div class="layout-row gap-sm p-sm">
              <mat-form-field elderFormFieldLabel>
                <mat-label>{{ 'shopfloor.workcenters.workcenter' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="workCenterNumber"
                  [ngModel]="segment.workCenterNumber"
                  readonly
                  placeholder="{{ 'shopfloor.workcenters.workcenter' | translate }}"
                />
              </mat-form-field>
              <mat-form-field elderFormFieldLabel>
                <mat-label>{{ 'shopfloor.workcenters.workcenter' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="workCenterName"
                  [ngModel]="segment.workCenterName"
                  readonly
                  placeholder="{{ 'shopfloor.workcenters.workcenter' | translate }}"
                />
              </mat-form-field>
              <mat-form-field elderFormFieldLabel>
                <mat-label>{{ 'numberSequences.numberSequence' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="numberSequence"
                  [ngModel]="segment.sequenceNumber"
                  readonly
                  placeholder="{{ 'numberSequences.numberSequence' | translate }}"
                />
              </mat-form-field>
            </div>
            <div class="layout-row gap-sm p-sm">
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>{{ 'processing.estimatedMakeSpan' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="plannedCapacityUsage"
                  [ngModel]="segment.plannedMakeSpan | isoDuration: 'dd:hh:mm:ss'"
                  readonly
                  placeholder="{{ 'context.plannedMakeSpan' | translate }}"
                />
              </mat-form-field>
            </div>
            <div class="layout-row gap-sm p-sm">
              <mat-form-field subscriptSizing="fixed">
                <mat-label>
                  {{ 'workBatches.startTime' | translate }}
                  {{ segment?.processingAudit?.startedAt | timeAgo }}
                </mat-label>
                <input
                  matInput
                  name="started"
                  [value]="segment?.processingAudit?.startedAt | date: 'short'"
                  readonly
                />
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed">
                <mat-label>
                  {{ 'workBatches.endTime' | translate }}
                  {{ segment?.processingAudit?.completedAt | timeAgo }}
                </mat-label>
                <input
                  matInput
                  name="completed"
                  [value]="segment?.processingAudit?.completedAt | date: 'short'"
                  readonly
                />
                @if (segment?.processingAudit?.completedBy; as completedBy) {
                  <mat-hint>{{ completedBy }}</mat-hint>
                }
              </mat-form-field>
              <mat-form-field subscriptSizing="fixed">
                <mat-label>{{ 'workBatches.duration' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="effectiveCapacityUsage"
                  [ngModel]="getActualMakeSpan(segment) | isoDuration: 'dd:hh:mm:ss'"
                  readonly
                  placeholder="{{ 'context.make-span' | translate }}"
                />
              </mat-form-field>
            </div>
            <h5 class="text-title-small">{{ 'properties.dynamic.title' | translate }}</h5>
            <app-bom-property-set-detail class="flex" [propertySet]="segment.properties">
            </app-bom-property-set-detail>
          </div>
        </mat-tab>
        <mat-tab [disabled]="!segment?.consumptionBom">
          <ng-template mat-tab-label>
            <span
              class="noselect"
              [matBadge]="segment?.consumptionBom?.namedItems?.length"
              [matBadgeHidden]="!segment?.consumptionBom"
              [matBadgeOverlap]="false"
              >{{ 'bom.cBom' | translate }}
            </span>
          </ng-template>
          <ng-template matTabContent>
            <app-bom-editor
              class="flex"
              style="overflow: hidden"
              [bom]="segment?.consumptionBom"
            ></app-bom-editor>
          </ng-template>
        </mat-tab>
        <mat-tab [disabled]="!segment?.finishedBom">
          <ng-template mat-tab-label>
            <span
              class="noselect"
              [matBadge]="segment?.finishedBom?.namedItems?.length"
              [matBadgeHidden]="!segment?.finishedBom"
              [matBadgeOverlap]="false"
              >{{ 'bom.fBom' | translate }}
            </span>
          </ng-template>
          <ng-template matTabContent>
            <app-bom-editor
              class="flex"
              style="overflow: hidden"
              [bom]="segment?.finishedBom"
            ></app-bom-editor>
          </ng-template>
        </mat-tab>
        <mat-tab [disabled]="!segment?.productModel">
          <ng-template mat-tab-label>
            <span class="noselect">{{ 'Product Model' | translate }}</span>
          </ng-template>
          <ng-template matTabContent>
            <app-bom-editor
              class="flex"
              style="overflow: hidden"
              [component]="segment?.productModel"
            ></app-bom-editor>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </elder-pane-content>
  </elder-pane>
}
